export default __webpack_public_path__ + "static/media/dr-seema.bc94d64e.png";